import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import TDPTableSelectRedux from "../TDP/TDPTableSelectRedux";
import TurmaDisciplinaProfessorProfileRedux from "../TDP/TurmaDisciplinaProfessorProfileRedux";
import Container from "../UI/Container";
import AtividadeForm from "./AtividadeForm";
import AtividadeTable from "./AtividadeTable";

export default function AtividadeContainer() {
  const tdp = useSelector((state) => state.tdp);
  const atividade = useSelector((state) => state.atividade);

  return (
    <Container>
      <Box mb={3}>
        <Typography variant="h6">Atividades</Typography>
        <Typography variant="body2" color="text.secondary">
          {tdp
            ? "Atividades da turma - disciplina e as notas ou entregas dos alunos."
            : "Selecione a turma e disciplina para ver as atividades."}
        </Typography>
      </Box>

      {tdp ? (
        <Stack spacing={3}>
          <TurmaDisciplinaProfessorProfileRedux />
          {atividade ? <AtividadeForm /> : <AtividadeTable />}
        </Stack>
      ) : (
        <TDPTableSelectRedux />
      )}
    </Container>
  );
}
